import './SetProfileLink.scss';

import { useState, useEffect } from 'react';
import { api } from '../../../utils/api';
import { useCurrentUser } from '../../../UserProvider';
import classNames from 'classnames';

export default function KickThingsOff({ setCanProceed, handleNext }) {
  const [displayName, setDisplayName] = useState('');
  const [profileId, setProfileId] = useState(null);
  const [displayNameError, setDisplayNameError] = useState(false);

  const { setCurrentUser } = useCurrentUser();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get(`/profiles?skip=0&limit=1`);

        if (data.length === 1) {
          setProfileId(data[0].id);
          setDisplayName(data[0].display_name);
        }
      } catch (err) {
        console.error("Failed to fetch data", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (profileId !== null) {
      setCanProceed(true);
    } else {
      setCanProceed(false);
    }
  }, [profileId, setCanProceed]);

  const handleCreate = async () => {
    const payload = {
      display_name: displayName,
    };

    if (displayName !== null && displayName.trim() !== "") {
      payload.display_name = displayName;
    } else {
      setDisplayNameError(true);
      return;
    }

    try {
      setDisplayNameError(false);
      if (profileId !== null) {
        await api.put(`/profiles/${profileId}`, payload);
        handleNext(true);
      } else {
        const {data} = await api.post(`/profiles`, payload);
        setProfileId(data.id);
        setCurrentUser(prev => ({ ...prev, display_name: displayName }));
        handleNext(true);
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setDisplayNameError(true);
      }
    }
  };

  return (
    <div className="__set_profile_link">
      <div className="title">LET'S KICK THINGS OFF</div>
      <div className="sub-title">Create a profile to showcase your talent and book more gigs</div>
      <div className={classNames("fade", "error", {show: displayNameError})}>
        Profile link already taken or invalid
      </div>
      <input
        type="text"
        placeholder="Choose a unique username"
        value={displayName}
        onChange={(e) => {
          const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9-_]/g, '');
          setDisplayName(sanitizedValue);
        }}
      />

      <button className="connect ppy-btn ppy-btn-primary" onClick={handleCreate}>
        Create My Papaya Profile
      </button>
    </div>
  );
}